<h1 class="page-title">Kik vagyunk?</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/rolunk']">Rólunk</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/kapcsolat']">Kapcsolat</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/komment']">Üzenj nekünk!</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/who-we-are.component.html